import { useState } from 'react';
import { ProgressiveConfiguration } from '~/gql/__generated__/types';
import ProgressiveLearnModal from '~/components/progressive-learn-modal';
import styles from './progressive-learn-more-link.module.scss';

interface ProgressiveLearnMoreLinkProps {
  linkText: string;
  progressiveConfigs: ProgressiveConfiguration;
}

const ProgressiveLearnMoreLink: React.FC<ProgressiveLearnMoreLinkProps> = ({
  linkText,
  progressiveConfigs,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    e.stopPropagation();
    toggleModal();
  };

  return (
    <>
      <a
        href="#"
        role={'button'}
        className={styles.buttonLink}
        tabIndex={0}
        aria-label="Learn How Progressive Leasing works"
        onClick={handleClick}
      >
        {linkText}
      </a>

      <ProgressiveLearnModal
        isModalOpen={isModalOpen}
        toggleModal={toggleModal}
        progressiveConfigs={progressiveConfigs}
      />
    </>
  );
};

export default ProgressiveLearnMoreLink;
